export const extendedFieldBankList = ['ITAÚ', 'DOBRASIL']
